/**
 * The four colours every briefing service draws, with the code beside them.
 *
 * The code is ALWAYS there in text. Colour is not an interface: red/green is the
 * commonest colour-vision deficiency there is, and this is a weather minimum.
 * The `title` carries the boundary the colour stands for, so a pilot who has
 * never seen the legend can find out what MVFR means without leaving the card.
 */
import { useT } from '../../i18n';
import type { FlightCategory } from '../../wx';

export function CategoryDot({ cat, size = 'md' }: { cat: FlightCategory | null; size?: 'sm' | 'md' }) {
  const t = useT();
  if (!cat) return null;
  const key = cat.toLowerCase();
  return (
    <span className={'wx-cat wx-cat-' + key + (size === 'sm' ? ' sm' : '')} title={t('wx.cat.' + key)}>
      <span className="wx-dot" aria-hidden="true" />
      {cat}
    </span>
  );
}
